import React from 'react'
import PropTypes from 'prop-types'
import {Heading, Link as NavLink} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import usePdTagManager from '../../../../../hooks/use-pd-tag-manager'
const CategoryTitle = ({
    title,
    titleColor,
    titleTag,
    isTextOverlay,
    titleFontFamily,
    titleBackground,
    isFullImage,
    shouldDisplayVideo = false,
    linkUrl,
    videoUrl,
    index,
    typeId
}) => {
    const appOrigin = useAppOrigin()
    const pdTagManager = usePdTagManager()
    const isExternalDomain = linkUrl?.indexOf('http') !== -1
    const linkProps =
        linkUrl && shouldDisplayVideo
            ? isExternalDomain
                ? {as: NavLink, href: linkUrl}
                : {as: RouteLink, to: linkUrl}
            : {}
    return (
        <Heading
            as={shouldDisplayVideo ? 'a' : titleTag}
            {...linkProps}
            className="category-title"
            maxWidth={{base: '100%', md: 'unset'}}
            margin="0"
            fontFamily={titleFontFamily || 'caslon'}
            lineHeight="normal"
            color={titleColor || 'black'}
            backgroundColor={titleBackground || 'white'}
            position={isTextOverlay ? 'absolute' : 'static'}
            fontWeight={isTextOverlay && titleFontFamily === 'cormorant' ? 500 : 400}
            paddingX={isTextOverlay ? '10px' : {base: '15px', lg: '18px', '2xl': '43px'}}
            bottom="0px"
            width="100%"
            textAlign="center"
            paddingY={
                isTextOverlay
                    ? {base: '10px'}
                    : isFullImage
                    ? {base: '7px', lg: '15px'}
                    : {base: '7px', '2xl': '15px'}
            }
            fontSize={isTextOverlay ? {base: '24px', md: '48px'} : {base: '20px', lg: '24px'}}
            letterSpacing={
                isTextOverlay ? {base: '0.17px', md: '0.12px'} : {base: '0.1px', md: '0.12px'}
            }
            _hover={{
                textDecoration: 'unset !important'
            }}
            onClick={() => {
                if (!shouldDisplayVideo) {
                    return
                }
                pdTagManager.selectComponent({
                    componentId: typeId,
                    componentName: name,
                    titleName: title,
                    titlePosition: index,
                    linkUrl: linkUrl?.indexOf('http') !== -1 ? linkUrl : `${appOrigin}${linkUrl}`,
                    videoUrl: videoUrl
                })
            }}
        >
            {title}
        </Heading>
    )
}

CategoryTitle.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleTag: PropTypes.string,
    isTextOverlay: PropTypes.any,
    titleFontFamily: PropTypes.string,
    titleBackground: PropTypes.any,
    isFullImage: PropTypes.any,
    shouldDisplayVideo: PropTypes.any,
    linkUrl: PropTypes.any,
    videoUrl: PropTypes.any,
    index: PropTypes.any,
    typeId: PropTypes.any
}

export default CategoryTitle
